export default {
    url: '/import',
    template: '<user-licence-point-import><user-licence-point-import/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/licencepoint/import/index.js